import { type ComponentPropsWithoutRef, forwardRef } from "react"

export type SpinnerSize = "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl"

export type SpinnerProps = ComponentPropsWithoutRef<"div"> & {
  /**
   * Indicates the diameter (height/width) of the `Spinner`'s container
   */
  "data-size"?: SpinnerSize
}

export const Spinner = forwardRef<HTMLDivElement, SpinnerProps>(
  // eslint-disable-next-line @typescript-eslint/no-shadow
  ({ className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`spinner-wrapper ${className ?? ""}`}
        {...props}
      >
        <div className="spinner" />
      </div>
    )
  },
)

Spinner.displayName = "Spinner"
